var map = {
	"./example.svg": "OOLB",
	"./eye.svg": "4wdf",
	"./form.svg": "sTIr",
	"./home.svg": "U9Ws",
	"./login-mall.svg": "xzZT",
	"./marker.svg": "0+/s",
	"./order-return-reason.svg": "PeRC",
	"./order-return.svg": "vigK",
	"./order-setting.svg": "LpN3",
	"./order.svg": "gYtG",
	"./password.svg": "QjmH",
	"./product-add.svg": "Cuqr",
	"./product-attr.svg": "Aain",
	"./product-brand.svg": "JTBo",
	"./product-cate.svg": "G6Qz",
	"./product-comment.svg": "b5pz",
	"./product-list.svg": "qzoa",
	"./product-recycle.svg": "WSWy",
	"./product.svg": "UHi4",
	"./sms-ad.svg": "2epx",
	"./sms-coupon.svg": "0Kk2",
	"./sms-flash.svg": "/KjT",
	"./sms-hot.svg": "If2y",
	"./sms-new.svg": "vvoC",
	"./sms-subject.svg": "4H1Q",
	"./sms.svg": "AS+9",
	"./table.svg": "oSYw",
	"./total-today.svg": "le/7",
	"./total-week.svg": "csmh",
	"./total-yesterday.svg": "C15R",
	"./tree.svg": "3eCm",
	"./ums-admin.svg": "FR/6",
	"./ums-menu.svg": "sr5k",
	"./ums-resource.svg": "noU8",
	"./ums-role.svg": "w7oB",
	"./ums.svg": "J4x9",
	"./user.svg": "VdD3"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 40